export default __webpack_public_path__ + "static/media/sommly1.314dc0bb.png";